module.exports = __webpack_public_path__ + "img/dept-2.b1e52e92.svg";